import { render, staticRenderFns } from "./phonecontrol.vue?vue&type=template&id=461c5586&scoped=true&"
import script from "./phonecontrol.vue?vue&type=script&lang=js&"
export * from "./phonecontrol.vue?vue&type=script&lang=js&"
import style0 from "./phonecontrol.vue?vue&type=style&index=0&id=461c5586&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c5586",
  null
  
)

export default component.exports